export type MetaFunnelSignalName = 'QuizStepViewed' | 'QuizStepCompleted' | 'AppStoreClicked';
export type MetaFunnelSignalEmitter = (
  name: MetaFunnelSignalName,
  properties: Record<string, string | number>,
  eventId: string,
) => boolean;

const screenNamePattern = /^(?:intro|mini_focus_session|social_proof|question_\d+)$/u;
const downloadMethods = new Set(['hero', 'final-cta', 'footer', 'badge', 'guest-checkout']);

export function createMetaFunnelSignals(emit: MetaFunnelSignalEmitter, visitId: string) {
  let runId: string | null = null;
  const sent = new Set<string>();
  const sendOnce = (key: string, name: MetaFunnelSignalName, properties: Record<string, string | number>) => {
    if (sent.has(key)) return false;
    try {
      if (!emit(name, properties, key)) return false;
      sent.add(key);
      return true;
    } catch {
      // Optional ad measurement cannot interrupt the funnel or App Store link.
      return false;
    }
  };
  const step = (kind: 'view' | 'complete', screenIndex: number, screenName: string) => {
    if (!runId || !Number.isInteger(screenIndex) || screenIndex < 0 || screenIndex > 100 || !screenNamePattern.test(screenName)) return false;
    return sendOnce(`quiz:${runId}:${kind}:${screenIndex}`, kind === 'view' ? 'QuizStepViewed' : 'QuizStepCompleted', {
      screen_index: screenIndex,
      screen_name: screenName,
    });
  };
  return {
    beginRun(nextRunId: string) {
      if (!/^[A-Za-z0-9-]{1,64}$/u.test(nextRunId)) return;
      if (nextRunId !== runId) {
        runId = nextRunId;
      }
    },
    stepViewed: (screenIndex: number, screenName: string) => step('view', screenIndex, screenName),
    stepCompleted: (screenIndex: number, screenName: string) => step('complete', screenIndex, screenName),
    appStoreClicked(method: string) {
      if (!/^[A-Za-z0-9-]{1,64}$/u.test(visitId) || !downloadMethods.has(method)) return false;
      return sendOnce(`download:${visitId}`, 'AppStoreClicked', { download_method: method });
    },
  };
}
